/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import {
  reduxForm,
  Field,
  change,
  formValueSelector,
  initialize
} from "redux-form";
import { connect } from "react-redux";
import {
  Label,
  FormGroup,
  Row,
  Col,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  Form,
  Button,
  InputGroup,
  InputGroupAddon,
  CustomInput
} from "reactstrap";
import { Input } from "../../../core";
import { required } from "../../../helper/validation";
import { TextClipper } from "../../../helper/TextFormatter";

const uuidv4 = require("uuid/v4");

class ReportAProblem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      supportTicketSizeExceeded: false
    };
  }

  componentDidMount() {
    this.props.initialize({ file: [] });
  }

  handleFileChange = e => {
    const files = Object.values(e.target.files);
    const formattedFiles = files.map(item => ({
      file: item,
      id: uuidv4(),
      url: URL.createObjectURL(item),
      name: item.name,
      type: "Image"
    }));
    const totalFiles = [...this.props.file, ...formattedFiles];
    this.props.change("file", totalFiles);
    this.validateTicketSize(totalFiles);
  };

  removeFileFromList = removeItem => {
    const filteredFiles = this.props.file.filter(
      item => item.id !== removeItem.id
    );
    this.validateTicketSize(filteredFiles);
    this.props.change("file", filteredFiles);
    const fileUpload = document.getElementById("report-image-upload");
    fileUpload.value = "";
  };

  validateTicketSize = files => {
    let file_size = 0;
    files.forEach(file => (file_size += file.file.size));
    const total_file_size = Math.round(file_size / 1024 / 1024);
    if (total_file_size > "9") {
      this.setState({ supportTicketSizeExceeded: true });
    } else {
      this.setState({ supportTicketSizeExceeded: false });
    }
  };

  render() {
    return (
      <div className="container">
        <Modal
          isOpen={this.props.reportAProblem}
          className={this.props.className}
        >
          <ModalHeader toggle={() => this.props.toggleReportAProblem(false)}>
            Report a Problem
          </ModalHeader>
          <ModalBody>
            <Form>
              <div className="globalForm globalForm--mod reportFormTitle">
                <FormGroup>
                  <div className="mt-1 globalInput">
                    <Field
                      label="Title"
                      component={Input}
                      name="title"
                      type="text"
                      validate={required}
                      placeholder="Title"
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="globalInput">
                    <Field
                      label="Description"
                      component={Input}
                      name="description"
                      type="textarea"
                      placeholder="Description"
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="mt-0 globalInput">
                    <Label htmlFor="upload">Attachment</Label>{" "}
                    <CustomInput
                      type="file"
                      id="report-image-upload"
                      accept={[".jpeg", ".png", ".jpg"]}
                      className={`upload-content ${this.state
                        .supportTicketSizeExceeded && "ticket-size-exceeded"}`}
                      name="myFile"
                      label="Upload a file"
                      onChange={this.handleFileChange}
                      style={{
                        cursor: "pointer"
                      }}
                      multiple
                    />{" "}
                    <span
                      className="invalid-feedback"
                      style={{
                        visibility: this.state.supportTicketSizeExceeded
                          ? "visible"
                          : "hidden",
                        display: this.state.supportTicketSizeExceeded
                          ? "block"
                          : "none"
                      }}
                    >
                      {" "}
                      File size should not exceed 9MB{" "}
                    </span>
                  </div>
                </FormGroup>{" "}
                <Field component="input" name="file" hidden />
              </div>
            </Form>
            {this.props.file && this.props.file.length > 0 && (
              <div className="ml-2 d-flex">
                {this.props.file.map(item => (
                  <span className="reportProblemImages">
                    <img src={item.url} alt={item.name} />
                    <i
                      className="fa fa-times-circle deleteImage"
                      onClick={() => this.removeFileFromList(item)}
                    />
                  </span>
                ))}
              </div>
            )}
            <small className="supportEmail ml-3">
              {" "}
              * For more inquires, feel free to contact at
              <span>
                &nbsp;
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@wicketsoft.com" target="_blank">
                  support@wicketsoft.com
                </a>
              </span>{" "}
            </small>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn-outline-primary"
              onClick={() => this.props.toggleReportAProblem()}
            >
              Cancel
            </Button>
            <Button
              className="primaryButton mt-0"
              onClick={this.props.handleSubmit(
                values =>
                  !this.state.supportTicketSizeExceeded &&
                  this.props.handleSubmitReport(values)
              )}
            >
              Report
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const ReportAProblemComponent = reduxForm({
  form: "ReportAProblemForm"
})(ReportAProblem);

export default connect(
  state => {
    const selector = formValueSelector("ReportAProblemForm");
    return {
      file: selector(state, "file") || undefined
    };
  },
  { change, initialize }
)(ReportAProblemComponent);
